<template>
    <div class="coupon-unused">
        <div class="input">
            <input type="search" v-model="code" placeholder="請輸入折扣代碼" ref="codeSearch">
            <div class="button" :class="{'green': code.length}" @click="exchange">兌換</div>
        </div>
        <div class="error">
            <div class="msg">
                {{ errMsg || '' }}
            </div>
        </div>
        <div class="empty" v-if="! coupons.length">
            <img src="@/assets/img/empty-ticket.png">
            <div class="title">
                目前沒有優惠卷
            </div>
        </div>
        <div class="list" v-else>
            <coupon-item v-for="coupon in coupons" :key="coupon.id" :coupon="coupon"/>
        </div>
    </div>
</template>

<script>
    import CouponItem from "./CouponItem";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "CouponUnused",
        components: {
            'coupon-item': CouponItem,
        },
        data() {
            return {
                code: '',
                errMsg: '',
            }
        },
        computed: {
            ...mapGetters(['coupons'])
        },
        methods: {
            exchange() {
                if ( ! this.code.length) {
                    return ;
                }

                this.addCoupon({code: this.code}).catch(err => {
                    this.errMsg = err.response.data.message;
                });
            },
            ...mapActions(['getCoupons', 'addCoupon'])
        },
        created() {
            this.getCoupons({processing: false});
            this.code = this.$route.query.code || '';
        },
        mounted() {
            if (this.code && this.$refs.codeSearch) {
                this.$refs.codeSearch.focus();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .coupon-unused {
        margin: 15px;
    }

    .input {
        display: flex;

        input {
            width: 100%;
            border: 1px solid rgba(221,221,221,1);
            border-radius: 4px;
            font-size: 14px;
            line-height: 20px;
            margin-right: 10px;
            padding: 10px;
        }

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            width: 48px;
            border: 1px solid rgba(221,221,221,1);
            border-radius: 4px;
            color: rgba(155,155,155,1);
            font-size: 14px;
            line-height: 20px;

            &.green {
                color: rgba(51,153,51,1);
                border: 1px solid rgba(51,153,51,1);
            }
        }
    }

    .error {
        padding: 3px 10px;

        .msg {
            height: 20px;
            color: rgba(244,67,54,1);
            font-size: 14px;
            line-height: 20px;
            text-align: left;
        }
    }

    input[type=radio]{
        &:checked {
            &.label {
                background-position : 0 -22px;
            }
        }
    }

    .empty {
        margin-top: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            height: 50px;
            width: 50px;
        }

        .title {
            margin-top: 30px;
            color: #4A4A4A;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
        }

        .button {
            margin-top: 34px;
            height: 25px;
            border-radius: 13px;
            background-color: #339933;
            color: #FFFFFF;
            font-size: 12px;
            line-height: 17px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
        }
    }
</style>